import { useContext } from 'react';

import { TrashContext } from 'contexts/trash/TrashContext';

export const useTrash = () => {
  const context = useContext(TrashContext);

  return context;
};
